import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.seo-collage' ).each( function( index, component ) {
        const splide0 = new Splide( $( component ).find( '.seo-collage__images--0' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '24px',
          autoWidth: true,
          autoHeight: true,
          height: $( component ).outerHeight(),
          pauseOnHover: false,
          direction: 'ttb',
          autoScroll: {
            speed: 0.5,
            autoStart: window.hasMotion ? true : false,
          },
        } );

        const splide1 = new Splide( $( component ).find( '.seo-collage__images--1' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '24px',
          autoWidth: true,
          autoHeight: true,
          height: $( component ).outerHeight(),
          pauseOnHover: false,
          direction: 'ttb',
          rtl: true,
          autoScroll: {
            speed: -0.5,
            autoStart: window.hasMotion ? true : false,
          },
        } );

        const splide2 = new Splide( $( component ).find( '.seo-collage__images--2' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '24px',
          autoWidth: true,
          autoHeight: true,
          height: $( component ).outerHeight(),
          pauseOnHover: false,
          direction: 'ttb',
          breakpoints: {
            1024: {
              direction: 'ltr',
              height: 'auto',
              autoWidth: true,
            },
          },
          autoScroll: {
            speed: 0.5,
            autoStart: window.hasMotion ? true : false,
          },
        } );

        const splide3 = new Splide( $( component ).find( '.seo-collage__images--3' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '24px',
          autoWidth: true,
          autoHeight: true,
          height: $( component ).outerHeight(),
          pauseOnHover: false,
          direction: 'ttb',
          rtl: true,
          breakpoints: {
            1024: {
              direction: 'ltr',
              height: 'auto',
              autoWidth: true,
              rtl: true,
            },
          },
          autoScroll: {
            speed: -0.5,
            autoStart: window.hasMotion ? true : false,
          },
        } );

        splide0.mount( {AutoScroll} );
        splide1.mount( {AutoScroll} );
        splide2.mount( {AutoScroll} );
        splide3.mount( {AutoScroll} );

        if ( !window.hasMotion ) {
          $( component ).find( '.loop-video-toggle-state' ).addClass( 'is-paused' );
        }

        $( component ).find( '.loop-video-toggle-state' ).on( 'click', function() {
          if ( $( this ).hasClass( 'is-paused' ) ) {
            splide0.Components.AutoScroll.play();
            splide1.Components.AutoScroll.play();
            splide2.Components.AutoScroll.play();
            splide3.Components.AutoScroll.play();
            $( this ).removeClass( 'is-paused' );
          } else {
            splide0.Components.AutoScroll.pause();
            splide1.Components.AutoScroll.pause();
            splide2.Components.AutoScroll.pause();
            splide3.Components.AutoScroll.pause();
            $( this ).addClass( 'is-paused' );
          }
        } );

        let resizeTimer;
        $( window ).on( 'resize', function() {
          clearTimeout( resizeTimer );
          resizeTimer = setTimeout( function() {
            const height = $( component ).outerHeight();
            splide0.options = {height};
            splide1.options = {height};
            splide2.options = {height};
            splide3.options = {height};
          }, 150 );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'seo-collage', COMPONENT );
} )( app );
